// @flow

import * as React from 'react';
import Box from 'sail/Box';
import {motion} from 'framer-motion';
import {
  useContentAnimation,
  variants,
  transition,
} from 'docs/shell/content/ContentAnimationProvider';

import './Page.scss';

type PageProps = {|
  children: React.Node,
  prefs: {[pref: string]: string},
  title?: string,
  badge?: {[key: string]: any},
|};

export const Page = ({children}: PageProps) => {
  const {direction} = useContentAnimation();
  return (
    <Box padding={{vertical: 12}} style={{overflow: 'hidden'}} className="Page">
      <motion.div
        key="Page"
        initial="enter"
        animate="center"
        exit="exit"
        custom={direction}
        variants={variants}
        transition={transition}
      >
        {children}
      </motion.div>
    </Box>
  );
};
